"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GEOLOCATION_USA = exports.GEOLOCATION_NOT_ALLOWED = exports.GEOLOCATION_COMING_SOON = exports.GEOLOCATION_ALLOWED = void 0;
var GEOLOCATION_COMING_SOON = exports.GEOLOCATION_COMING_SOON = 'coming-soon';
var GEOLOCATION_ALLOWED = exports.GEOLOCATION_ALLOWED = 'allowed';
var GEOLOCATION_NOT_ALLOWED = exports.GEOLOCATION_NOT_ALLOWED = 'not-allowed';
var GEOLOCATION_USA = exports.GEOLOCATION_USA = 'usa';